import WishListService from '../../assets/js/Dashboard/wishListService';
import { dataLayerEvents } from '../dataLayerEvents';
import Tooltip from '../tooltip';
import Cookies from '../services/cookies';

class RecentlyViewedProducts {
    constructor() {
        if ($('#futurumClient').data('route') === 'search') {
            return;
        }

        this.wishListService = new WishListService();
        this.getProducts();
        $("button.addToWishlist").on('click', (event) => {
            const $currentTarget = $(event.currentTarget);
            const productData = $currentTarget.data().product;

            event.stopPropagation();

            if (!$currentTarget.hasClass('is-active')) {
                dataLayerEvents.addToWishList(productData);
            }

            this.wishListService.toggleWishList($currentTarget);
        });
    }

    getProducts () {
        const oldRvpId = this.getCookie('recentlyViewedProductsId');
        const rvpId = oldRvpId || this.getCookie('__Host-recentlyViewedProductsId');
        if (oldRvpId) {
            this.setCookie('recentlyViewedProductsId', '', -1);
            this.setCookie('__Host-recentlyViewedProductsId', oldRvpId, 60);
        }

        const $spinner = $('.spinner');
        const $emptyBlock = $('.js-empty-block');
        const $footer = $('.footer');
        const $uspbar = $('.js_footer-uspbar');
        const $rvpContainer = $('.rvpContainer');

        if (!rvpId || !$rvpContainer.length) {
            $spinner.addClass('hidden');
            $emptyBlock.addClass('hidden');
            return;
        }

        $.ajax({
            dataType: 'json',
            url: '/products/recently-viewed?id=' + rvpId,
            type: 'get',
            cache: false,
            success: function (response) {
                $('.rvpContainer').html(response.template);
                this.attachClickEvent();
                (new Tooltip()).initRVP();
                if (history.state && history.state.scrollPosition) {
                    $(document).scrollTop(history.state.scrollPosition);
                    history.pushState({scrollPosition: ''}, null, '');
                }
            }.bind(this)
        });

        $spinner.addClass('hidden');
        $emptyBlock.addClass('hidden');
    }

    getCookie(key) {
        let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');

        return keyValue ? keyValue[2] : null;
    }

    setCookie(cname, cvalue, exdays) {
        let cookies = new Cookies();
        cookies.setCookie(cname, cvalue, exdays);
    }

    attachClickEvent() {
        $(".rvpContainer button.addToWishlist").on('click', (event) => {
            event.stopPropagation();

            this.wishListService.toggleWishList($(event.currentTarget));
        });

        $('.rvpContainer .productCard .image a, .rvpContainer .productCard .text a, .brandsContainer .brand').on('click', function (event) {
            event.preventDefault();

            const url = $(this).attr('href');
            const scrollPosition = $(document).scrollTop();

            history.pushState({scrollPosition}, null, '');
            window.location.href = `${url}`;
        });

        this.attachProductCartClickEvent();
    }

    attachProductCartClickEvent() {
        const $product = $('.js_product-card');

        $product.each((i, item) => {
            const $item = $(item);
            const url = $item.data().commonurl;

            $item.click(() => {
                window.location.href = url;
            })
        })
    }
}

$(document).ready(function () {
    new RecentlyViewedProducts();
});
